import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { _User } from "@opendash/plugin-parse-schema";
import { Button, Drawer, Empty, Spin, Tag, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import { useEffect, useState } from "react";
import { getUsername } from "../helper/getUsername";

type Props = {
  user: _User;
};

export const UserRoleDrawer = observer((props: Props) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [roles, setRoles] = useState<Parse.Role[]>([]);
  const [loading, setLoading] = useState(false);
  const t = useTranslation();

  useEffect(() => {
    if (!drawerOpen) return;

    const fetchRoles = async () => {
      setLoading(true);
      try {
        const query = new Parse.Query(Parse.Role);
        query.equalTo("users", props.user);
        query.ascending("name");
        const result = await query.find();
        setRoles(result);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, [drawerOpen, props.user]);

  if (!props.user || !props.user.getUsername) {
    return null;
  }

  return (
    <>
      <Tooltip
        title={t("siv:user.classconfig.entry.tooltip", {
          username: getUsername(props.user) || "",
        })}
      >
        <Button
          type="text"
          icon={<Icon icon="fa:user-tag" />}
          onClick={() => setDrawerOpen(true)}
        />
      </Tooltip>

      <Drawer
        title={
          <>
            <Icon icon="fa:user-tag" style={{ marginRight: 8 }} />
            Rollen für {getUsername(props.user)}
          </>
        }
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        width={400}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin />
          </div>
        ) : roles.length === 0 ? (
          <Empty description="Keine Rollen zugewiesen" />
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {roles.map((role) => (
              <div
                key={role.id}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Tag
                  icon={
                    <Icon icon="fa:shield-alt" style={{ marginRight: 4 }} />
                  }
                  color="blue"
                  style={{ fontSize: 13, padding: "4px 10px" }}
                >
                  {(role.get("label") as string | undefined) || role.getName()}
                </Tag>
                {role.get("label") && (
                  <span
                    style={{ marginLeft: 8, color: "#8c8c8c", fontSize: 12 }}
                  >
                    {role.getName()}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </Drawer>
    </>
  );
});
